enum CommissionType {
  Consumer = 'Consumer',
  SubCp = 'SubCp',
}

export default CommissionType;
